import type { TagProps } from 'antd';
import { Tag } from 'antd';
import type * as React from 'react';
import { cn } from '@/lib/utils';

export type BadgeVariant =
  | 'default'
  | 'secondary'
  | 'destructive'
  | 'outline'
  | 'orange'
  | 'coral'
  | 'success'
  | 'warning'
  | 'info';

export interface BadgeProps extends Omit<TagProps, 'color' | 'variant'> {
  variant?: BadgeVariant;
}

// variant 对应的样式
const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-primary/10 text-primary border-primary/20',
  secondary: 'bg-secondary text-secondary-foreground border-transparent',
  destructive: 'bg-destructive/10 text-destructive border-destructive/20',
  outline: 'bg-transparent text-muted-foreground border-border-strong',
  orange: 'bg-orange-100 text-orange-700 border-orange-200',
  coral: 'bg-red-50 text-red-600 border-red-200',
  success: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  warning: 'bg-amber-50 text-amber-700 border-amber-200',
  info: 'bg-blue-50 text-blue-700 border-blue-200',
};

const Badge: React.FC<BadgeProps> = ({
  className,
  variant = 'default',
  children,
  ...props
}) => {
  return (
    <Tag
      bordered={true}
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium border transition-colors',
        variantStyles[variant],
        className,
      )}
      {...props}
    >
      {children}
    </Tag>
  );
};

Badge.displayName = 'Badge';

export { Badge };

// 同时导出 antd Tag 供直接使用
export { Tag as NativeTag };
export type { TagProps as NativeTagProps };
